import React from "react";

// components
import SectionContainer from "core/SectionContainer";
import CollectionSpotlight from "core/CollectionSpotlight";
import OffsetGrid from "core/OffsetGrid";
import SocialProof from "core/SocialProof";
import TestimonialSection from "core/TestimonialSection";
import BlogPosts from "core/BlogPosts";
import CardsTwoUp from "core/CardsTwoUp";
import Faq from "core/Faq";
import BulletLeft from "core/BulletLeft";
import Heading from "core/Heading";
import TextWithButton from "core/TextWithButton";
import colors from "core/colors";

import CircleCluster from "./images/circleCluster.svg";
import RocketSvg from "./images/rocket.svg";

// data
import {
    metaTitle,
    metaDescription,
    mainHeading,
    mainSubHeading,
    getStartedBtn,
    bulletAPIFeatures,
    socialProofHeading,
    socialProofIcons,
    sectionFourHeading,
    sectionFourSubHeading,
    sectionFourBtns,
    testimonials,
    caseStudies,
    caseStudiesTitle,
    caseStudiesSubTitle,
    planTitle,
    cards,
    faqTitle,
    faq
} from "./data";
import PageMeta from "core/PageMeta";

const APILandingPage = () => {
    return (
        <>
            <PageMeta
                useSocialMediaTags
                title={metaTitle}
                description={metaDescription}
                previewImg="https://static.production.thenounproject.com/img/nounproject_logo.60e860f212a5.png"
            />
            <SectionContainer bottomSpacing="none" topSpacing="2xl">
                <OffsetGrid sm={10} md={12} lg={10}>
                    <CollectionSpotlight
                        sideBySideContentOnMedium
                        isBottomImageOnMobile
                        isRightImg
                        collectionHeading={mainHeading}
                        collectionText={mainSubHeading}
                        collectionLink={getStartedBtn}
                        imageAlt={mainHeading}
                        image={CircleCluster}
                        headingType="h1"
                        headingSize="2xl"
                        headingColor={colors.secondary.orca}
                        buttonProps={{ styleType: "cta" }}
                    />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer topSpacing="xl">
                <OffsetGrid sm={10} md={12} lg={10}>
                    <BulletLeft bullets={bulletAPIFeatures} />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer bgColor={colors.primary.diamond}>
                <OffsetGrid sm={10} md={12} lg={10}>
                    <SocialProof
                        icons={socialProofIcons}
                        headingText={socialProofHeading}
                        headingType="div"
                        headingSize="xl"
                        headingColor={colors.secondary.orca}
                        headingBottomSpacing="2xl"
                        headingAlignment="center"
                        iconsAlignment="center"
                    />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer>
                <OffsetGrid sm={10} md={12} lg={10}>
                    <CollectionSpotlight
                        sideBySideContentOnMedium
                        isBottomImageOnMobile
                        collectionHeading={sectionFourHeading}
                        collectionText={sectionFourSubHeading}
                        collectionLink={sectionFourBtns}
                        imageAlt={mainHeading}
                        image={RocketSvg}
                        headingType="h1"
                        headingSize="2xl"
                        headingColor={colors.secondary.orca}
                    />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer bgColor={colors.primary.diamond}>
                <OffsetGrid sm={10} md={12} lg={8}>
                    <TestimonialSection testimonials={testimonials} />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <TextWithButton
                        text={caseStudiesTitle}
                        subtext={caseStudiesSubTitle}
                        subtextAlignment="left"
                        bottomSpacing="3xl"
                    />
                    <BlogPosts
                        posts={caseStudies}
                        headingAlignment="left"
                        subtitleLinkInverse={true}
                    />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer bgColor={colors.primary.diamond}>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <Heading size="xl" type="h2" bottomSpacing="xl">
                        {planTitle}
                    </Heading>
                    <CardsTwoUp cards={cards} />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <Faq
                        title={faqTitle}
                        values={faq}
                        headingAlignment="left"
                    />
                </OffsetGrid>
            </SectionContainer>
        </>
    );
};

export default APILandingPage;
